import styles from "./FooterBar.module.css";
import { GrInstagram} from "react-icons/gr";
function FooterBar() {
  return (
    <footer className={styles.footerbar}>
      <div className={styles.redes}>
        <a href="https://www.instagram.com/geografiaemjogosufpel/"><GrInstagram></GrInstagram></a>
        <p>Acompanhe nossos conteúdos</p>
        
      </div>
      <p id={styles.p1}>
        © 2022 Desenvolvido Por:
        <a href="https://nathanielfarias.netlify.app/">Nathaniel Farias</a>
      </p>
      <div id={styles.p2}>
        <p>© 2022 Desenvolvido Por:</p>
        <p>
          <a href="https://nathanielfarias.netlify.app/">Nathaniel Farias</a>
        </p>
      </div>
    </footer>
  );
}
export default FooterBar;
